import React, { useState, useEffect, useRef } from 'react';
import MapboxEx from '../MapboxEx'


// mapbox をラップした関数コンポーネント
function Map(props) {
    const mapContainerRef = useRef(null);

    const [lng, setLng] = useState(process.env.REACT_APP_INITIAL_LONGITUDE || 139.752778);
    const [lat, setLat] = useState(process.env.REACT_APP_INITIAL_LATITUDE || 35.6825);
    const [zoom, setZoom] = useState(process.env.REACT_APP_INITIAL_ZOOM || 9);

    // map オブジェクトの初期化は一度だけ行う。
    useEffect(() => {
        const mapboxex = new MapboxEx(mapContainerRef, lng, lat, zoom);

        mapboxex.mapbox.on('move', () => {
            setLng(mapboxex.mapbox.getCenter().lng);
            setLat(mapboxex.mapbox.getCenter().lat);
            setZoom(mapboxex.mapbox.getZoom());
        });

        mapboxex.mapbox.on('moveend', () => {
            if (props.onMoveEnd) {
                props.onMoveEnd(
                    mapboxex.mapbox.getCenter(),
                    mapboxex.mapbox.getZoom()
                );
            }
        });

        mapboxex.mapbox.on('move', () => {
            if (props.onMove) {
                props.onMove(
                    mapboxex.mapbox.getCenter(),
                    mapboxex.mapbox.getZoom()
                );
            }
        });

        mapboxex.mapbox.on('load', async () => {
            mapboxex.initHandlers();

            // fill pattern 用のイメージを読み込む。
            {
                const patterns = [
                    { name: 'wide-upward-diagonal-green', url: './images/wide-upward-diagonal-green.png' },
                    { name: 'percent-10', url: './images/percent-10.png' },
                    { name: 'large-grid', url: './images/large-grid.png' },
                    { name: 'stripe_black', url: './images/stripe_black@2x.png', options: { pixelRatio: 2 } }
                ];

                await Promise.all(patterns.map(pattern => {
                    return mapboxex.loadImage(pattern)
                        .catch((error) => {
                            console.error(error)
                        })
                }));
            }

            if (props.onLoad) {
                props.onLoad(mapboxex);
            }
        });

        return () => mapboxex.mapbox.remove();
    }, []);

    return (
        <div ref={mapContainerRef} className="map-container" />
    );
}

export default Map;